import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CAPACITY_QUOTAS, CAPACITY_QUOTA_KEYS, MONTHLY_QUOTAS, MONTHLY_QUOTA_KEYS } from "@/constants/quotas";
import type { PlanLimits } from "@/services/plans.service";

interface PlanAllowancesProps {
  limits: PlanLimits;
}

interface QuotaCellProps {
  label: string;
  limit: number | null | undefined;
  showDisabled?: boolean;
}

function QuotaCell({ label, limit, showDisabled = false }: QuotaCellProps) {
  return (
    <div className="p-3 border rounded-lg space-y-1">
      <dt className="text-xs text-muted-foreground">{label}</dt>
      <dd className="font-semibold flex flex-wrap items-center gap-2">
        {limit === null || limit === undefined ? "Unlimited" : limit.toLocaleString()}
        {showDisabled && limit === 0 && <Badge variant="outline">Disabled</Badge>}
      </dd>
    </div>
  );
}

export function PlanAllowances({ limits }: PlanAllowancesProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Feature Limits</CardTitle>
        <CardDescription>Allowances included in your plan.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <section aria-label="Monthly API allowances" className="space-y-3">
          <h3 className="text-sm font-medium">Monthly API allowances</h3>
          <dl className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {MONTHLY_QUOTA_KEYS.map((key) => (
              <QuotaCell key={key} label={MONTHLY_QUOTAS[key].label} limit={limits[key]} showDisabled />
            ))}
          </dl>
        </section>
        <section aria-label="Capacity limits" className="space-y-3">
          <h3 className="text-sm font-medium">Capacity limits</h3>
          <dl className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {CAPACITY_QUOTA_KEYS.map((key) => (
              <QuotaCell key={key} label={CAPACITY_QUOTAS[key].label} limit={limits[key]} />
            ))}
          </dl>
        </section>
      </CardContent>
    </Card>
  );
}
